import BaseComponent from "./BaseComponent";

export default class SearchBarComponent extends BaseComponent
{
    constructor(id) {
        super();

        this._id = id;
        this._exists = true;

        if( $(id).length < 1 ) {
            this._exists = false;
            return;
        }

        this._bindListener( 'submit', this._onSubmit, id );
        this._bindListener( 'loaded', this._prefill);
    }

    exists() {
        return this._exists;
    }

    _prefill() {
        var href = window.location.href.split('?')[1]

        href.split('&').forEach(function(val, i) {
            var p = val.split('=');

            if( p[0] == "q" ) {
                $('.blb-search-input').val( unescape(p[1]) );
            }
        });
    }

    _onSubmit( event ) {
        event.preventDefault();

        let data    = $.parseJSON( $(this._id + ' input[type="radio"]:checked').first().val().replace(/\'/g, '"') ),
            search  = $(this._id + ' input[type="text"]').val();

        if( $.type(data[0]) == 'string' ) {
            window.location = data[0] + "?" + data[1] + "=" + encodeURIComponent(search);
        }
    }
}